<template>
    <b-col>
        <b-row align-h="center" style="margin-top: 30px; margin-bottom: 30px">
            <b-col>
                <span style="font-size: 1.1em; font-weight: bold;">{{ $t('wasteTableTitle') }}</span>
            </b-col>
        </b-row>
        <b-row v-if="isLoaded">
            <b-col cols="12" sm="4" md="12" lg="6" v-if="pieChartData.datasets[0].data.length">
                <div style="width: 26em; height: 26em; margin: auto;">
                    <doughnut-chart :chart-data="pieChartData" :options="pieChartOptions" :chart-id="pieChartId"/>
                </div>
            </b-col>
            <b-col v-else>
                <span>{{ $t('emissionError') }}</span>
            </b-col>
            <b-col cols="12" sm="10" md="12" lg="6">
                <div class="table-responsive">
                    <table v-if="hasAnyCarbonConsumption" class="table table-hover" style="table-layout: fixed; font-size: 0.875em; border-top: none !important;">
                        <thead class="borderless" style="text-align: center">
                            <tr>
                                <th style="text-align: left; width: 14em">{{ $t('emissionType') }}</th>
                                <th style="text-align: right">{{this.year - 1}}</th>
                                <th style="text-align: right">{{this.year}}</th>
                                <th>{{ $t('carbonEmissionChanging') }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(consumption,key) in waste" v-if="key !== 'total'">
                                <td style="text-align: left" v-if="
                                $t(consumption.displayName) !== 'Cartridge' &&
                                $t(consumption.displayName) !== 'Kartuş' &&
                                $t(consumption.displayName) !== 'Toner' &&
                                $t(consumption.displayName) !== 'Fluorescence' &&
                                $t(consumption.displayName) !== 'Floresan' &&
                                $t(consumption.displayName) !== 'Tehlikeli Atık (diğer)' &&
                                $t(consumption.displayName) !== 'Dangerous Waste (other)'">{{$t(consumption.displayName)}} (kg)</td>
                               
                                <td style="text-align: left" v-else-if="$t(consumption.displayName) === 'Dangerous Waste (other)'">{{$t(consumption.displayName)}} (-)</td>
                                <td style="text-align: left" v-else-if="$t(consumption.displayName) === 'Tehlikeli Atık (diğer)'">{{$t(consumption.displayName)}} (-)</td>
                                <td style="text-align: left" v-else>{{$t(consumption.displayName)}} ({{$t("adet")}})</td>

                                <td style="text-align: right">{{consumption.past | parseNumber('float', locale) | convertZeroValueToDash(locale)}}</td>
                                <td style="text-align: right">{{consumption.current | parseNumber('float', locale) | convertZeroValueToDash(locale)}}</td>
                                <td style="text-align: center">
                                    <b-row no-gutters align-h="between" v-if="calculateRatio(consumption.past, consumption.current) !== '0.00'">
                                        <b-col cols="6">
                                            <b-row no-gutters>
                                                <b-col cols="11" style="text-align: right">
                                                    <img v-if="calculateRatio(consumption.past, consumption.current) < 0" width="16px" height="16px" src="../../../../assets/icon/down-round-g.svg"/>
                                                    <img v-else width="16px" height="16px" src="../../../../assets/icon/up_round_r.svg"/>
                                                </b-col>
                                            </b-row>
                                        </b-col>
                                        <b-col cols="6" style="text-align: left">
                                            {{ calculateRatio(consumption.past, consumption.current) | absoluteNumber | parseNumber('float', locale) }}
                                        </b-col>
                                    </b-row>
                                    <b-row no-gutters align-h="end" v-else>
                                        <b-col cols="6" style="text-align: left">-</b-col>
                                    </b-row>
                                </td>
                            </tr>
                            <!-- total is removed because of different unit types of values.
                            <tr>
                                <th style="text-align: left">{{waste.total.displayName}} (ton)</th>
                                <th style="text-align: right">{{waste.total.past | parseNumber('float', locale) | convertZeroValueToDash(locale)}}</th>
                                <th style="text-align: right">{{waste.total.current | parseNumber('float', locale) | convertZeroValueToDash(locale)}}</th>
                                <th>
                                    <b-row no-gutters align-h="between" v-if="calculateRatio(waste.total.past, waste.total.current) !== '0.00'">
                                        <b-col cols="6">
                                            <b-row no-gutters>
                                                <b-col cols="11" style="text-align: right">
                                                    <img v-if="calculateRatio(waste.total.past, waste.total.current) < 0" width="16px" height="16px" src="../../../../assets/icon/down-round-g.svg"/>
                                                    <img v-else width="16px" height="16px" src="../../../../assets/icon/up_round_r.svg"/>
                                                </b-col>
                                            </b-row>
                                        </b-col>
                                        <b-col cols="6" style="text-align: left">
                                            {{ calculateRatio(waste.total.past, waste.total.current) | absoluteNumber | parseNumber('float', locale) }}
                                        </b-col>
                                    </b-row>
                                    <b-row no-gutters align-h="end" v-else>
                                        <b-col cols="6" style="text-align: left">-</b-col>
                                    </b-row>
                                </th>
                            </tr>
                            !-->
                        </tbody>
                    </table>
                </div>
            </b-col>
        </b-row>
    </b-col>
</template>

<script>
import _ from 'lodash';
import uuidV4 from 'uuid/v4';

import globalFilters from '../../../../filters';
import DoughnutChart from '../../../../components/charts/DoughnutChart';

export default {
    name: 'TotalWasteProduced',
    props: {
        initialWaste: {
            type: Object,
            default() {
                return {
                    currentWaste: [],
                    pastWaste: []
                };
            }
        },
        selectedSiteId: {
            default() {
                return null;
            }
        },
        selectedSiteGroupId: {
            default() {
                return null;
            }
        }
    },
    components: {DoughnutChart},
    data() {
        return {
            isLoaded: false,
            pieChartId: uuidV4(),
            waste: [],
            colourPalette: [
                'rgba(250,164,58,1)',
                'rgba(96,189,104,1)',
                'rgba(247,82,133,1)',
                'rgba(93,165,218,1)',
                'rgba(222,207,63,1)',
                'rgba(178,118,178,1)',
                'rgba(77,77,77,1)',
                'rgba(178,145,47,1)',
                'rgba(222,207,63,1)',
                'rgba(241,88,84,1)'
            ],
            pieChartData: {
                labels: [],
                datasets: [
                    {
                        label: 'Toplam Tüketim',
                        labels: [],
                        hoverBorderWidth: [],
                        hoverBorderColor: [],
                        backgroundColor: [],
                        data: []
                    }
                ]
            },
            pieChartOptions: {
                /*
                    layout: {
                        padding: {
                            top: 110,
                            left: 10,
                            bottom: 10,
                            right: 10
                        }
                    },
                    */
                responsive: false,
                maintainAspectRatio: false,
                title: {
                    display: false,
                    text: 'Toplam Atık Miktarı',
                    fontSize: 16,
                    fontColor: '#555'
                },
                tooltips: {
                    callbacks: {
                        label: (tooltipItem, data) => {
                            let label = ' ';
                            label +=
                                data.datasets[tooltipItem.datasetIndex].labels[tooltipItem.index] ||
                                '';
                            if (label) {
                                label += ': ';
                            }
                            let total = data.datasets[tooltipItem.datasetIndex].data.reduce(
                                (accumulator, currentValue) => accumulator + currentValue
                            );
                            let ratio = (
                                data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index] /
                                total *
                                100
                            ).toFixed(1);
                            return label + globalFilters.localizedRatioText(ratio, this.locale);
                        }
                    }
                },
                animation: {
                    duration: 1500,
                    animateScale: true,
                    easing: 'easeOutQuint',
                    onComplete: function() {
                        /*
							let chartInstance = this.chart;
							let textCtx = chartInstance.ctx;

							textCtx.textAlign = 'center';
							textCtx.textBaseline = 'middle';
							textCtx.font = '24px Avenir';
							textCtx.fillStyle = '#676763';
							textCtx.fillText("2017", 148, 260);
							*/
                    }
                },
                legend: {
                    position: 'bottom',
                    labels: {
                        padding: 15,
                        align: 'center',
                        boxAlign: 'center'
                    },
                    onClick: function(e, legendItem) {
                        let segment = this.chart.getDatasetMeta(0).data[legendItem.index];
                        this.chart.tooltip._active = [segment];
                        this.chart.tooltip.update();
                        this.chart.render(300, true);
                        return {e, legendItem};
                        /*
							  var index = legendItem.index;
							  var ci = this.chart;
							  var meta = ci.getDatasetMeta(0);
							  // See controller.isDatasetVisible comment
							  meta.data[index].hidden = !meta.data[index].hidden;
							  // We hid a dataset ... rerender the chart
							  ci.update();
							  */
                    }
                }
            }
        };
    },
    methods: {
        calculateRatio(lastValue, currentValue) {
            if (!lastValue) {
                return '0.00';
            }
            let subtraction = currentValue - lastValue;
            let ratio = subtraction / lastValue;
            return (ratio * 100).toFixed(2);
        },
        prepareTotalCarbonConsumptionsDataSet(waste) {
            // Resets pieChartData
            this.pieChartData.datasets = [
                {
                    labels: [],
                    hoverBorderWidth: [],
                    hoverBorderColor: [],
                    backgroundColor: [],
                    data: []
                }
            ];
            this.pieChartData.labels = [];
            _.sortBy(waste.current, 'value')
                .reverse()
                .forEach((consumption, index) => {
                    this.pieChartData.datasets[0].labels.push(this.$t(consumption.type));
                    this.pieChartData.labels.push(this.$t(consumption.type));
                    this.pieChartData.datasets[0].hoverBorderWidth.push(6);
                    this.pieChartData.datasets[0].hoverBorderColor.push(
                        this.colourPalette[index % 10]
                    );
                    this.pieChartData.datasets[0].backgroundColor.push(
                        this.colourPalette[index % 10]
                    );
                    this.pieChartData.datasets[0].data.push(consumption.value);
                });
            this.isLoaded = true;
            // Rerenders piechart
            this.$eventHub.$emit(this.pieChartId);
            return waste;
        },
        prepareTotalCarbonConsumptionsTable(waste) {
            let prepared = {
                total: {
                    displayName: this.$t('total'),
                    current: 0,
                    past: 0
                }
            };

            _.sortBy(waste.current, [
                function(o) {
                    return o.value;
                }
            ])
                .reverse()
                .forEach(consumption => {
                    if (prepared.hasOwnProperty(consumption.type)) {
                        prepared[consumption.type].current += Number(consumption.value.toFixed(2));
                    } else {
                        prepared[consumption.type] = {
                            displayName: consumption.type,
                            current: Number(consumption.value.toFixed(2)),
                            past: 0
                        };
                    }
                    prepared.total.current += consumption.value;
                });

            waste.past.forEach(consumption => {
                if (prepared.hasOwnProperty(consumption.type)) {
                    prepared[consumption.type].past += Number(consumption.value.toFixed(2));
                } else {
                    prepared[consumption.type] = {
                        displayName: consumption.type,
                        current: 0,
                        past: Number(consumption.value.toFixed(2))
                    };
                }
                prepared.total.past += consumption.value;
            });

            prepared.total.current = Number(prepared.total.current.toFixed(2));
            prepared.total.past = Number(prepared.total.past.toFixed(2));

            this.waste = prepared;
        },
        filterConsumptions(waste) {
            let current = waste.currentWaste;
            let past = waste.pastWaste;
            if (this.selectedSiteGroupId) {
                let sitesOfRegion = this.sites.filter(site => {
                    return site.siteGroupId === this.selectedSiteGroupId;
                });
                if (this.selectedSiteId) {
                    current = current.filter(consumption => {
                        return (
                            _.find(sitesOfRegion, {id: consumption.site_id}) &&
                            consumption.site_id === this.selectedSiteId
                        );
                    });
                    past = past.filter(consumption => {
                        return (
                            _.find(sitesOfRegion, {id: consumption.site_id}) &&
                            consumption.site_id === this.selectedSiteId
                        );
                    });
                } else {
                    current = current.filter(consumption => {
                        return _.find(sitesOfRegion, {id: consumption.site_id});
                    });
                    past = past.filter(consumption => {
                        return _.find(sitesOfRegion, {id: consumption.site_id});
                    });
                }
            } else if (this.selectedSiteId) {
                current = current.filter(consumption => {
                    return consumption.site_id === this.selectedSiteId;
                });
                past = past.filter(consumption => {
                    return consumption.site_id === this.selectedSiteId;
                });
            }

            return Promise.resolve({current, past});
        },
        aggregateConsumptions(waste) {
            let reducedCurrent = _.reduce(
                waste.current,
                function(result, consumption) {
                    let foundEmission = _.find(result, {type: consumption.type});
                    if (foundEmission) {
                        foundEmission.value += consumption.value;
                    } else {
                        result.push(consumption);
                    }
                    return result;
                },
                []
            );

            let reducedPast = _.reduce(
                waste.past,
                function(result, consumption) {
                    let foundEmission = _.find(result, {type: consumption.type});
                    if (foundEmission) {
                        foundEmission.value += consumption.value;
                    } else {
                        result.push(consumption);
                    }
                    return result;
                },
                []
            );

            reducedCurrent = reducedCurrent.filter(data => {
                return data.value !== 0;
            });
            reducedPast = reducedPast.filter(data => {
                return data.value !== 0;
            });
            return Promise.resolve({current: reducedCurrent, past: reducedPast});
        },
        processCarbonConsumptions(data) {
            this.prepareTotalCarbonConsumptionsDataSet(data);
            this.prepareTotalCarbonConsumptionsTable(data);
        }
    },
    computed: {
        hasAnyCarbonConsumption() {
            return this.waste && Object.keys(this.waste).length;
        }
    },
    watch: {
        initialWaste(data) {
            this.processCarbonConsumptions(data);
        },
        selectedSiteId() {
            this.processCarbonConsumptions(this.initialWaste);
        },
        selectedSiteGroupId() {
            this.processCarbonConsumptions(this.initialWaste);
        }
    },

    mounted() {
        this.processCarbonConsumptions(this.initialWaste);
    }
};
</script>

<style scoped>
</style>

<i18n src="../../../../i18n/common.json"></i18n>
<i18n src="../../../../i18n/carbonEmissionTable.json"></i18n>
<i18n>
    {
        "tr": {
            "wasteTableTitle": "Atık Takip Tablosu",
            "emissionType": "Atık Tipi"
        },
        "en": {
            "wasteTableTitle": "Waste Amount Table",
            "emissionType": "Waste Type"
        }
    }


</i18n>



// WEBPACK FOOTER //
// src/views/Analysis/Tabs/components/TotalWasteProduced.vue